import PropTypes from 'prop-types';

import CheckIcon from '@mui/icons-material/Check';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Box, IconButton, InputAdornment } from '@mui/material';

import TextFieldComponent from '../../FormField/TextFieldComponent';

import { COMMUNITY_COMMENT_INPUT_ID } from '../constants';

const CommentInputComponent = (props) => {
  const { postId, comment, onSetComment, onCommentSubmit, disabled } = props;

  const textFieldId = `${COMMUNITY_COMMENT_INPUT_ID}_${postId}`;

  return (
    <Box display="flex" width="100%" alignItems="center">
      <TextFieldComponent
        id={textFieldId}
        input={{
          value: comment,
          onChange: (event) => onSetComment(event.target.value),
        }}
        meta={{ active: Boolean(comment) }}
        disabled={disabled}
        characterLimit={280}
        placeholder="Add comment"
        type="text"
        multiline
        FormHelperTextProps={{ component: 'div', sx: { margin: 0 } }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {comment.length > 0 && (
                <IconButton
                  aria-label="clear-comment"
                  onClick={() => onSetComment('')}
                  edge="end"
                >
                  <HighlightOffIcon fontSize="small" />
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
      />
      {comment.length > 0 && (
        <IconButton
          aria-label="send-comment"
          onClick={onCommentSubmit}
          edge="end"
        >
          <CheckIcon color="primary" />
        </IconButton>
      )}
    </Box>
  );
};

CommentInputComponent.propTypes = {
  postId: PropTypes.number.isRequired,
  comment: PropTypes.string.isRequired,
  onSetComment: PropTypes.func.isRequired,
  onCommentSubmit: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default CommentInputComponent;
